import { render, staticRenderFns } from "./training-goal.vue?vue&type=template&id=16486f09"
import script from "./training-goal.vue?vue&type=script&lang=js"
export * from "./training-goal.vue?vue&type=script&lang=js"
import style0 from "./training-goal.vue?vue&type=style&index=0&id=16486f09&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports